import type { Teacher as TeacherData } from '@mathflat/domain/Teacher'

import { Teacher } from './Teacher'

// 매쓰플랫 사용하는 선생님 유저
export class User extends Teacher {
  constructor({ teacher }: { teacher?: TeacherData }) {
    super(teacher)

    Object.assign(this)
  }
}
